
import Vue from 'vue'

import CustomTextModal from './CustomTextModal.vue'
import { RButton } from '@/components'

export default Vue.extend({
  name: 'NonStudioLimitReached',
  components: {
    CustomTextModal,
    RButton,
  },
})
